import React from 'react';
import { Media } from 'reactstrap';
// import { Btn, Image } from '../../AbstractElements';
import { Navigator } from '../Table/Defaultdata';

const style2 = { width: 60, fontSize: 14, padding: 4 };
export const stafftabledata = [
    {
        id: 1,
        name: 
        // <Media className='d-flex'><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: `${user1}`, alt: 'Generic placeholder image' }} />
            <Media body className="align-self-center">
                <div className="f-w-700 font-success">Gojo Satoru</div>
            </Media>,
        // {/* </Media>, */}
        // date: '2023/04/27',
        emyployeeId: <span>#PX0101 <i className="fa fa-pencil"></i></span>,
        role: 'Receptionist',
        qualification: 'B.com',
        aadharnumber: '1233-2222-6666',
        contactnumber: <span className="f-w-700">9988776656</span>,
        action: <span>
        {/* <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button' }}>Edit </Btn> */}
        <Navigator to={`${process.env.PUBLIC_URL}/staffform/:layout`}/>
      </span>
        // budget: '$3142.00',

    },
];

export const tableColumns = [
    {
        name: '#',
        selector: row => row['id'],
        sortable: true,
        center: false,
    },
    {
        name: 'Name',
        selector: row => row['name'],
        sortable: true,
        center: false,
    },
    // {
    //     name: 'Date',
    //     selector: row => `${row.date}`,
    //     sortable: true,
    //     center: true,
    // },
    {
        name: 'Employee Id',
        selector: row => row['emyployeeId'],
        sortable: true,
        center: true,
    },
    {
      name: 'Role',
      selector: row => `${row.role}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Qualification',
      selector: row => `${row.qualification}`,
      sortable: true,
      center: true,
  },
    {
        name: 'Aadhar Number',
        selector: row => row['aadharnumber'],
        sortable: true,
        center: true,
    },
    {
        name: 'Contact Number',
        selector: row => row['contactnumber'],
        sortable: true,
        center: true,
    },
    
    {
        name: 'Action',
        selector: row => row['action'],
        sortable: false,
        center: true,
    },
];